import React, {useEffect, useMemo, useRef, useState} from "react";
import {useLocation} from "react-router-dom";
import {PageHeader} from "../../../components/PageHeader";
import CodeManageSettingsLayout from "../fieldMng/shared/CodeManageSettingsLayout";
import CompanyManagePanel from "../company/CompanyManagePanel";
import DepartmentManagePanel from "../department/DepartmentManagePanel";
import {
    COMPANY_DEPARTMENT_CATEGORIES,
    COMPANY_DEPARTMENT_ROUTE_CATEGORY,
    pickBasicSettingsCategory, USER_ACCOUNT_GROUP_CATEGORIES,
} from "./basicSettingsCategoryConfig";
import "../fieldMng/shared/unifiedCodeManage.css";
import "../fieldMng/shared/codeManageSettings.css";
import {isAdmin} from "../../../components/commonmethod/CommonMethod";
import {useSelector} from "react-redux";

function CompanyDepartmentManage() {
    const location = useLocation();
    const companyPanelRef = useRef(null);
    const [companyView, setCompanyView] = useState("list");
    const user = useSelector((state) => state.auth.user);
    const auth = isAdmin(user);
    const [activeCategory, setActiveCategory] = useState(() =>
        pickBasicSettingsCategory(
            COMPANY_DEPARTMENT_CATEGORIES,
            "company",
            COMPANY_DEPARTMENT_ROUTE_CATEGORY,
            location.pathname,
        ),
    );

    const activeMeta = useMemo(
        () => COMPANY_DEPARTMENT_CATEGORIES.find((item) => item.id === activeCategory)
            ?? COMPANY_DEPARTMENT_CATEGORIES[0],
        [activeCategory],
    );

    useEffect(() => {
        const nextId = pickBasicSettingsCategory(
            COMPANY_DEPARTMENT_CATEGORIES,
            activeCategory,
            COMPANY_DEPARTMENT_ROUTE_CATEGORY,
            location.pathname,
        );
        if (nextId && nextId !== activeCategory) {
            setActiveCategory(nextId);
        }
    }, [location.pathname]);

    useEffect(() => {
        setCompanyView("list");
    }, [activeCategory]);

    const isCompanyCreate = activeCategory === "company" && companyView === "create";

    const panelTitle = isCompanyCreate ? "업체 등록" : activeMeta.title;
    const panelDescription = isCompanyCreate
        ? "새 협력업체·고객사 정보를 등록합니다."
        : activeMeta.description;

    const panelHeadActions = activeCategory === "company" ? (
        isCompanyCreate ? (
            <>
                <button
                    type="button"
                    className="code-manage-neutral-btn"
                    onClick={() => setCompanyView("list")}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="save-btn"
                    onClick={() => companyPanelRef.current?.submitCreate()}
                >
                    저장
                </button>
            </>
        ) : (
            <button
                type="button"
                className="save-btn"
                onClick={() => setCompanyView("create")}
            >
                등록
            </button>
        )
    ) : null;

    const fullPanel = activeCategory === "company"
        ? (
            <CompanyManagePanel
                ref={companyPanelRef}
                viewMode={companyView}
                onViewModeChange={setCompanyView}
            />
        )
        : <DepartmentManagePanel />;

    return (
        <div className="common-container container-height-full">
            <PageHeader
                header="업체 · 부서 관리"
                indicator="환경설정 > 기본설정 > 업체 · 부서 관리"
            />
            <CodeManageSettingsLayout
                navItems={auth ? COMPANY_DEPARTMENT_CATEGORIES : COMPANY_DEPARTMENT_CATEGORIES.filter((item) => item.id !== "department")}
                activeCategory={activeCategory}
                onCategoryChange={setActiveCategory}
                panelTitle={panelTitle}
                panelDescription={panelDescription}
                panelHeadActions={panelHeadActions}
                fullPanel={fullPanel}
            />
        </div>
    );
}

export default CompanyDepartmentManage;
